<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div>
  	<headlink v-if="parent == '0'"></headlink>
    <headlink1 v-if="parent == '1'"></headlink1>
    <!--<div class="hello">
    <header class="header ui-header-positive ui-border-b" style="padding:0 210px">
      <ul class="ui-tiled">
        <div><img src="/static/img/logo.png" /> </div>
        <router-link to="/devicemanage" tag="li"><div>设备控制</div></router-link>
        <router-link to="/addDevice" tag="li"><div>添加设备</div></router-link>
        <router-link to="/userManage" tag="li"><div>用户管理</div></router-link>
        <router-link to="/msgLog" tag="li"><div>消息记录</div></router-link>
        <router-link to="/send" tag="li"><div>指令群发</div></router-link>
        <router-link to="/baidu" tag="li" class="active" ><div>地图位置</div></router-link>
        <router-link to="/info" tag="li"><div>个人信息</div></router-link>
       
        
        <li v-on:click="logOut()"><div  >退出</div></li>
      </ul>
    
    </header>
  </div>-->
   
   <div id="singlemap" style="height: 880px; width: 100%;"></div>
   <div id="r-result" style="display: none;">
		<div class="optionpanel">
			<label>选择主题</label>
			<select id="stylelist" onchange="changeMapStyle(this.value)"></select>
		</div>
		
	</div>   
</div>
	

</template>

<script>

import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'
import BMap from 'BMap'
import BMapSymbolSHAPEPOINT from 'BMap_Symbol_SHAPE_POINT'
  export default {
    name: 'info',
    data () {
      return {
        uId:"",
        eqId:"",
        parent: "0"
        }
    },
		  
      mounted: function () {
      	this.eqId=this.$route.params.eqId;
      	const history = window.sessionStorage;
			var uid = history.getItem("user");
			var parent = history.getItem("parent");
			this.parent = parent;
      	
     var bm = new BMap.Map("singlemap");
         bm.addControl(new BMap.NavigationControl());
         bm.enableScrollWheelZoom();
         bm.enableContinuousZoom(); 
        var sel = document.getElementById('stylelist');
	for(var key in mapstyles){
		var style = mapstyles[key];
		var item = new  Option(style.title,key);
		sel.options.add(item);
	}
	changeMapStyle('normal')
	sel.value = 'normal';

	function changeMapStyle(style){
		
		bm.setMapStyle({style:style});
		$('#desc').html(mapstyles[style].desc);
	}
         $.ajax({
			type:"post",
			url:"http://localhost:8080/ZYun/HttpService.do",
			contentType: "application/json; charset=utf-8",
			async:true,
			data:JSON.stringify(getJsonData(this.eqId)),
			dataType:'json',
			success:function(data){
		   
			            
		             if( data.eqLon !=null && data.eqLat!=null){
		             	
		             	
		             	
		             	var x = data.eqLon;
                        var y = data.eqLat;
		                var coords = x+','+y;  	
		       	
		             $.ajax({
					type:"get",
					dataType:'jsonp',
					processData: false,
					url:"http://api.map.baidu.com/geoconv/v1/?coords="+coords+"&from=3&to=5&output=json&ak=PnOLHS34HgAmAEyKylVyecVz0Q2lnZmZ",
					async:true,
					success:function(date){
						
						console.log(data);
					
						var point = new BMap.Point(date.result[0].x,date.result[0].y);
						var icon;
						bm.centerAndZoom(point, 15);
						console.log(point);
						if (data.eqState == 0) {
					   	   if (data.eqType == 11) {
					   	   	var icon = new BMap.Icon('/static/img/siludingweihongditu.png', new BMap.Size(30, 30));
					   	   } else if (data.eqType == 6){
					   	   	console.log("dfsafd");
					   	   	var icon = new BMap.Icon('/static/img/danludingweihongditu.png', new BMap.Size(25, 25));
					   	   }else if (data.eqType == 5){
					   	   	
					   	   	var icon = new BMap.Icon('/static/img/dingwei_hongditu.png', new BMap.Size(25, 25));
					   	   }
					   	
					   	} else {
					   		if (data.eqType == 11) {
					   			var icon = new BMap.Icon('/static/img/siludingweilvditu.png', new BMap.Size(30, 30));
					   		} else  if (data.eqType == 6 ) {
					   			var icon = new BMap.Icon('/static/img/danludingweilvditu.png', new BMap.Size(25, 25));
					   		}  else if (data.eqType == 5) {
					   		var icon = new BMap.Icon('/static/img/dingwei_lvditu.png', new BMap.Size(25, 25));
					   		}
					   		
					   		
					   		
					   		
					   		
					   	}
						
						
						
			 	 		 var marker = new BMap.Marker(point,{icon:icon});  // 创建标注
               			  marker.setAnimation(BMAP_ANIMATION_BOUNCE);
               			bm.addOverlay(marker);
               			  var content = "<table>";
               			  content = content + "<tr><td> 设备ID:"+data.eqId+"</td></tr>";
                     content = content + "<tr><td> 设备名称:"+data.eqName+"</td></tr>";
                     
                     content += "</table>";
                     var infowindow = new BMap.InfoWindow(content);	
               		
                     marker.openInfoWindow(infowindow);
                    			(function() {
               				var thePoint = data.eqId;
               				marker.addEventListener("click", function() {
               					fanhui(thePoint);
               				});
               			})();

               			},
               			error: function(XMLHttpRequest, textStatus, errorThrown) {
               			console.log(XMLHttpRequest.status);
               			console.log(XMLHttpRequest.readyState);
               			console.log(textStatus);
               			}
               			});	
      
		            
		}

               			}
             
               })

               			
               			function fanhui(eqId){
				
				window.location.href="http://localhost:8080/#/devicemanage?tiaozhuan="+eqId;
				
			
				
			}
               			
               			
               			function  getJsonData(eqId) {
                        const history = window.sessionStorage;
			                 	var uid = history.getItem("user");
                       
                       if (eqId.length == 9) {
         					      eqId="0"+eqId
        				      } 
            			      
                 
		var json = {
				"serviceCode": "1011",
				"uId": uid,
				"eqId":eqId
			}
			return json;
		}
      
        
   
    }, 
           
           

    components: {
      headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
</style>-->



// WEBPACK FOOTER //
// src/components/baidu/ditu.vue